import { render, staticRenderFns } from "./LiveJourneys.vue?vue&type=template&id=71333d7a"
import script from "./LiveJourneys.vue?vue&type=script&lang=js"
export * from "./LiveJourneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports